import { render, staticRenderFns } from "./WhatsappAppearance.vue?vue&type=template&id=216bffc5&"
import script from "./WhatsappAppearance.vue?vue&type=script&lang=js&"
export * from "./WhatsappAppearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports